import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * This Error exists so that we can specifically
 * capture and handle this particular error in the
 * ErrorBoundary
 */
export var markdownConversionErrorName = 'MarkdownConversionError';
export var MarkdownConversionError = /*#__PURE__*/function (_Error) {
  function MarkdownConversionError(_ref) {
    var _this;
    var message = _ref.message,
      type = _ref.type;
    _classCallCheck(this, MarkdownConversionError);
    _this = _callSuper(this, MarkdownConversionError, [message]);
    _this.name = markdownConversionErrorName;
    _this.type = type;
    return _this;
  }
  _inherits(MarkdownConversionError, _Error);
  return _createClass(MarkdownConversionError);
}( /*#__PURE__*/_wrapNativeSuper(Error));